import React, { useCallback, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../../kingpin/atoms/Button';
import V3ContentScreenContext from './V3ContentScreenContext';

const V3ContentBackButton = ({ fallback }: { fallback?: JSX.Element }) => {
  const { content, isIndexScreen } = useContext(V3ContentScreenContext);

  const navigate = useNavigate();
  const location = useLocation();
  const onClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  if (!content || !isIndexScreen) {
    if (fallback) {
      return <>{fallback}</>;
    }
    return null;
  }

  // When a content screen is opened directly (e.g. in a new tab), this is the
  // first history entry and its key is 'default' — there is nothing to go back
  // to within the app, so we hide the Back button entirely.
  if (location.key === 'default') {
    return null;
  }

  return (
    <Button
      label="Back"
      icon={'arrow-left'}
      onClick={onClick}
      type={'Ghost'}
      size="Small"
    />
  );
};

export default V3ContentBackButton;
